import React, { Component } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom';

import LoadingModal from "../../components/modal/LoadingModal";
import { getUserList } from '../../resources/API';
import moment from 'moment';
import Filter from "./components/Filter";

const defaultFilterCriteria = {
  merchantId: "",
  merchantCode: "",
  merchantName: "",
  username:"",
  status: "",
  tableFilter: {
      page : 1,
      sizePerPage : 25,
      sortOrder : "desc",
      sortField : "createdDatetime"
  }
};

class UserTable extends Component {

  constructor(props) {
    super();
    defaultFilterCriteria.merchantId = props.merchantId;
    const filterCriteria = props.location && props.location.state ?
                                props.location.state.filterCriteria :
                                {...defaultFilterCriteria};

    const tableHeader = [
      { text: "Id", dataField: "id", sort: true, hidden:true },
      { text: "Username", dataField: "username", sort: true },
      { text: "Username", dataField: "usernameText", hidden: true },
      { text: "Full Name", dataField: "fullName", sort: true },
      { text: "Create Date", dataField: "createdDatetime", sort:true },
      { text: "Last Login", dataField: "lastLogin", sort:true },
      {
        text: "Status", dataField: "status", sort: true, align:'center',headerAlign:'center',
        headerStyle: () => {
          return { width: '80px'};
        }
      }
    ];

    this.state = {
      filterCriteria: {...filterCriteria},
      searchedCriteria: {...filterCriteria},
      tableHeader: tableHeader,
      tableBody: [],
      tableCount : 0,
      loadingShow: false
    }
  }

  handleFilterCriteriaSubmit = () => {
    const { filterCriteria } = this.state;
    this.getData(filterCriteria);
    this.setState({
        searchedCriteria: {...filterCriteria}
    });
}

  handleTableChange = (type, props) => {
    const {searchedCriteria} = this.state;
        const tableChangeCriteria = {...searchedCriteria,
                                        tableFilter: {
                                            page : props.page,
                                            sizePerPage : props.sizePerPage,
                                            sortOrder : props.sortOrder,
                                            sortField : props.sortField
                                        }
                                    };
        this.getData(tableChangeCriteria);
        this.setState({
            searchedCriteria: {...tableChangeCriteria}
        });
  }

  handleRefresh = () => {
    this.getData(this.state.searchedCriteria);
  }

  handleFilterCriteriaChange = (e) => {
    let { name, value } = e.target;
    let currentState = this.state.filterCriteria;
    currentState[name] = value;

    this.setState({
        filterCriteria: currentState
    });
}

  handleFilterCriteriaReset = () => {
    this.setState({
      filterCriteria: {...defaultFilterCriteria}
    });
  }

  getData = async (criteria) => {
    this.setState({loadingShow : true});
      const userListResponse = await getUserList(criteria);
      if((userListResponse && userListResponse.status === 200)){
          const userList = userListResponse.body.getAllResponse.userProfileList;
          const tableCount = userListResponse.body.getAllResponse.totalSize;
          const tableBody = userList.map((user) => {
            const userLink = "/user/view/" + user.merchantId + "/" + user.userId;
            const statusBadge = () => {
              switch (user.status) {
                case 'A' : return <Badge pill variant={"success"}>{"ACTIVE"}</Badge>;
                case 'I' : return <Badge pill variant={"secondary"}>{"INACTIVE"}</Badge>;
                case 'L' : return <Badge pill variant={"danger"}>{"LOCKED"}</Badge>;
              }
            }
            return {
                id : user.userId,
                merchantId : user.merchantId,
                merchantName : user.merchantName,
                fullName : user.fullName,
                username : <Link to={{
                              pathname:userLink,
                              state:{
                                role: this.props.role,
                                filterCriteria: this.state.searchedCriteria,
                                accessToken: this.props.accessToken,
                                username: this.props.username
                                }
                              }}>
                            {user.username}
                          </Link>,
                createdDatetime : moment(user.createdDatetime,"YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss"),
                lastLogin : user.lastLogin ? moment(user.lastLogin,"YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss") : "",
                status : statusBadge(),
              }
          });
          this.setState({
            tableBody : tableBody,
            tableCount : tableCount
          });
      }
      this.setState({loadingShow : false});
  }

  render() {
    const { role, accessToken, username} = this.props;
    const { loadingShow, tableHeader, tableBody, filterCriteria, searchedCriteria, tableCount } = this.state;
    const defaultSorted = [{
      dataField: searchedCriteria.tableFilter.sortField, // if dataField is not match to any column you defined, it will be ignored.
      order: searchedCriteria.tableFilter.sortOrder // desc or asc
    }];
    const options = {
      custom: true,
      sizePerPage:searchedCriteria.tableFilter.sizePerPage,
      page:searchedCriteria.tableFilter.page,
      totalSize: tableCount,
      sizePerPageList: [{
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: '75', value: 75
      }, {
        text: '100', value: 100
      }],
      alwaysShowAllBtns: true,
      firstPageText: 'First',
      prePageText: 'Prev',
      nextPageText: 'Next',
      lastPageText: 'Last'
    };
    return (
      <React.Fragment>
        <PaginationProvider pagination={paginationFactory(options)}>
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={tableBody}
              columns={tableHeader}
              search
            >
              {toolkitprops => {
                return (
                  <Card className="shadow mt-4 mx-auto card-width-1200">
                    <Card.Header className="pt-3 pb-2 bg-white">
                      <Row>
                        <Col sm={12} className="text-scb font-weight-bold">
                          User Profile
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col sm={9}>
                          <Filter
                            criteria={filterCriteria}
                            onSubmit={this.handleFilterCriteriaSubmit}
                            onChange={this.handleFilterCriteriaChange}
                            onReset={this.handleFilterCriteriaReset}
                            onTableChange = {this.handleTableChange}
                          />
                        </Col>
                        <Col sm={{ span: 2, offset: 1 }}  style={{display: "flex", alignItems: "center",justifyContent: "flex-end", paddingLeft: 0}} className="text-right">
                          <LinkContainer
                            to={{
                              pathname: "/user/create",
                                state: {
                                  role: role,
                                  filterCriteria: searchedCriteria,
                                  accessToken: accessToken,
                                  username: username
                                }
                            }}
                            activeClassName="">
                            <Button variant="scb">New User</Button>
                          </LinkContainer>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <BootstrapTable
                            hover
                            striped
                            bordered={false}
                            defaultSorted={defaultSorted}
                            noDataIndication={"No data found"}
                            {...toolkitprops.baseProps}
                            {...paginationTableProps}
                            remote={ {
                              filter: true,
                              pagination: true,
                              sort: true,
                              cellEdit: false
                            } }
                            onTableChange={ this.handleTableChange }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={"auto"} className="mr-auto">
                          <span className="mr-1">Display</span>
                          <SizePerPageDropdownStandalone btnContextual="btn-scb" {...paginationProps} />
                          <span className="ml-1 mr-1">records per page.</span>
                          <PaginationTotalStandalone {...paginationProps} />
                        </Col>
                        <Col sm={"auto"}>
                          <PaginationListStandalone {...paginationProps} />
                        </Col>
                      </Row>

                    </Card.Body>
                  </Card>
                )
              }}
            </ToolkitProvider>
          )}
        </PaginationProvider>
        <LoadingModal show={loadingShow} />
      </React.Fragment>
    );
  }
}

export default UserTable;